export default class FormatUtils {

    formatDate(date) {
        if (date == null)
            return '';

        return this.formatDateTimeFromDate(this.dateFromString(date), false);
    }

    formatDateTime(date) {
        if (date == null)
            return '';

        return this.formatDateTimeFromDate(this.dateTimeFromString(date), true);
    }

    formatDateStringFromLocale(dateSting, locale) {
        if (dateString === null)
            return '';

        var date = this.dateFromString(dateSting);
        if (date.toString() === 'Invalid Date') {
            return '';
        }

        return this.formatDateFromLocale(date, locale);
    }

    formatDateTimeStringFromLocale(dateString, locale) {
        if (dateString === null)
            return '';

        var date = this.dateTimeFromString(dateString);
        if (date.toString() === 'Invalid Date') {
            return '';
        }

        return this.formatDateTimeFromLocale(date, locale);
    }

    formatDateFromLocale(date, locale) {
        var dateFormat = this.getDateFormatFromLocale(locale);

        return this.formatDateTimeFromFormat(date, dateFormat)
    }

    formatDateTimeFromLocale(date, locale) {
        var dateFormat = this.getDateFormatFromLocale(locale) + ' HH:mm';

        return this.formatDateTimeFromFormat(date, dateFormat)
    }

    getDateFormatFromLocale(locale) {
        switch (locale) {
            case "de-DE": return "DD.MM.YYYY";

            case "en-US": return "MM/DD/YYYY";

            case "en-GB":
            case "es-ES":
            case "nl-NL":
            default:
                return "DD-MM-YYYY";
        }
    }


    formatDateTimeFromFormat(date, format) {
        format = format.replace("DD", this.pad(date.getDate(), 2))
        format = format.replace("MM", this.pad(date.getMonth() + 1, 2))
        format = format.replace("YYYY", this.pad(date.getFullYear(), 4))
        format = format.replace("HH", this.pad(date.getHours(), 2))
        format = format.replace("mm", this.pad(date.getMinutes(), 2))

        format = format.replace("D", date.getDate())
        format = format.replace("M", date.getMonth() + 1)
        format = format.replace("YY", date.getFullYear())
        format = format.replace("H", date.getHours())
        format = format.replace("m", date.getMinutes())

        return format
    }

    formatDateForStorage(date) {
        var returnValue =
            this.pad(date.getFullYear(), 4) + "-" +
            this.pad(date.getMonth() + 1, 2) + "-" +
            this.pad(date.getDate(), 2)
        return returnValue;
    }

    formatDateTimeForStorage(date) {
        var returnValue =
            this.pad(date.getUTCFullYear(), 4) + "-" +
            this.pad(date.getUTCMonth() + 1, 2) + "-" +
            this.pad(date.getUTCDate(), 2) + "T" +
            this.pad(date.getUTCHours(), 2) + ":" +
            this.pad(date.getUTCMinutes(), 2) + ":00";

        return returnValue;
    }

    formatDateTimeFromDate(date, includeTime) {
        var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

        var returnValue = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();

        if (includeTime)
            returnValue += " " + this.pad(date.getHours(), 2) + ":" + this.pad(date.getMinutes(), 2);

        return returnValue;
    }

    dateFromString(s) {
        if (s === undefined || s === null)
            return undefined;

        var bits = s.toString().split(/[-TZ:+]/g);

        if (bits[0].length == 4)
            return new Date(bits[0], bits[1] - 1, bits[2])
        else
            return new Date(bits[2], bits[1] - 1, bits[0])
    }

    dateTimeFromString(s) {
        if (s === undefined || s === null)
            return undefined;

        var bits = s.toString().split(/[-TZ:+]/g);
        //var d = Date(bits[0], bits[1] - 1, bits[2]);
        //d.setHours(bits[3], bits[4], bits[5]);
        if (bits.length === 3) // For userdefined fields
            return this.dateFromString(s)
        else
            return new Date(Date.UTC(bits[0], bits[1] - 1, bits[2], bits[3], bits[4], bits[5]));
    }


    pad(num, size) {
        var s = num + "";

        while (s.length < size)
            s = "0" + s;

        return s;
    }

    formatPercentage(data) {
        return data + " %";
    }

    formatMoney(data, decimals, currency) {
        if (data === null)
            return null;

        if (!currency)
            currency = '€'

        var decimalSeparator = Number("1.2").toLocaleString().substr(1, 1);

        var amountWithCommas = data.toLocaleString();
        var arParts = String(amountWithCommas).split(decimalSeparator);

        if (decimals > 0) {
            var fixed = data.toFixed(decimals);
            var sDecimals = fixed.substring(fixed.length - decimals, fixed.length);

            return currency + ' ' + arParts[0] + decimalSeparator + sDecimals;
        }

        return currency + ' ' + arParts[0];

        //var intPart = arParts[0];
        //var decPart = (arParts.length > 1 ? arParts[1] : '');
        //decPart = (decPart + '000000000').substr(0, decimalen);

        //return '€ ' + intPart + decimalSeparator + decPart;
    }

    formatDecimal(data, decimalen) {
        if (data === null)
            return null;

        var decimalSeparator = Number("1.2").toLocaleString().substr(1, 1);

        var amountWithCommas = data.toLocaleString();
        var arParts = String(amountWithCommas).split(decimalSeparator);

        if (decimalen > 0) {
            var fixed = data.toFixed(decimalen);
            var decimals = fixed.substring(fixed.length - decimalen, fixed.length);

            return arParts[0] + decimalSeparator + decimals;
        }

        return arParts[0];
    }

    formatBoolean(data, trueValue, falseValue) {
        if (data) {
            return trueValue;
        }
        return falseValue;
    }
}